import { classes } from '../const';

const { isActive } = classes;

const tabs = () => {

  const $$tabs = $('.js-tabs');
  $$tabs.each((i, el) => {
    const $$tabLinks = $(el).find('.js-tab-link');

    $$tabLinks.each((j, tabLink) => {
      const tabId = $(tabLink).data('tab');
      const $targetTab = $(el).find(`.js-tab-content[data-tab="${tabId}"]`);

      $(tabLink).click(event => {
        event.preventDefault();
        const $activeTab = $(el).find('.js-tab-content:visible');

        if ($activeTab[0] === $targetTab[0]) return;

        $$tabLinks.removeClass(isActive);
        $(tabLink).addClass(isActive);


        $activeTab.fadeOut(() => {
          $targetTab.fadeIn();
        });

      });
    });
  });
};

export default tabs;
